import React, { useContext } from 'react';
import styles from './Styles';
import { AppContext } from 'App.context';
import AppTextInput from 'Components/common/AppTextInput/AppTextInput';
import AppButton from 'Components/common/Forms/AppButton/AppButton';
import { UserAddOutlined } from '@ant-design/icons';
// import PMSSelector from './AddCustomers/PMSSelector';

export default function AddCustomerModal({ actions, state }) {
  const {
    appActions: { translate },
  } = useContext(AppContext);

  return (
    <div style={{ paddingRight: '10%', paddingLeft: '10%' }}>
      <div style={styles.iconModal}>
        <UserAddOutlined />
      </div>
      <div style={styles.titleModal}>
        <p>{translate('customers.newCustomerDetail.addNewCustomer')}</p>
      </div>
      <AppTextInput
        value={state.chainName}
        name={translate('customers.newCustomerDetail.chainName')}
        onChange={value => actions.setField('chainName', value)}
      />
      <AppTextInput
        value={state.name}
        name={translate('customers.newCustomerDetail.name')}
        onChange={value => actions.setField('name', value)}
      />
      <AppTextInput
        value={state.phone}
        name={translate('customers.newCustomerDetail.phone')}
        onChange={value => actions.setField('phone', value)}
      />
      <AppTextInput
        value={state.email}
        name={translate('customers.newCustomerDetail.email')}
        onChange={value => actions.setField('email', value)}
      />
      {/* <PMSSelector
        pmsList={state.pmsList}
        actions={actions}
        state={state}
        label={translate('customers.newCustomerDetail.pms')}
      />
      <AppTextInput
        value={state.countryChain}
        name={translate('customers.newCustomerDetail.countryChain')}
        onChange={value => actions.setField('countryChain', value)}
      /> */}
      <div style={{ paddingLeft: 60 }}>
        <AppButton
          text={translate('customers.newCustomerDetail.create')}
          action={() => actions.validateFieldsAndSend()}
          style={{ width: '80%' }}
        />
      </div>
    </div>
  );
}
